import { ActionBarSpacer } from "$components/action-bar/action-bar-spacer";
import { Page } from "$components/page";
import { useUser } from "$global-providers/user-provider";
import { Role } from "elephant-web/gql";
import { Outlet } from "react-router-dom";
import { RegisterActionBar } from "./_lib/register-action-bar";

export const RegisterLayout: FC = () => {
  const { role } = useUser();
  return (
    <>
      <Page style={{ overflowX: "auto" }}>
        <Outlet />
        {/* Collapses to nothing unless RegisterActionBar is actually showing. */}
        <ActionBarSpacer />
      </Page>
      {role === Role.Clinic && <RegisterActionBar />}
    </>
  );
};
